var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecuritycenter = function SvgSecuritycenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.152 2.355 10 .833l6.848 1.522a.833.833 0 0 1 .652.813v8.323a5 5 0 0 1-2.227 4.16L10 19.167 4.727 15.65A5 5 0 0 1 2.5 11.49V3.169c0-.39.271-.728.652-.813Zm1.015 1.482v7.654c0 1.114.557 2.155 1.484 2.773l4.349 2.9 4.35-2.9a3.333 3.333 0 0 0 1.483-2.772V3.837L10 2.542 4.167 3.837Zm6.666 4.496h2.5l-4.166 5.834V10h-2.5l4.166-5.833v4.166Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
export default SvgSecuritycenter;